<template>
  <div class="login">
    <div class="title">欢迎登录成睿软件在线学习系统</div>
    <div class="login-form">
      <a-form :form="form" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="请输入登录账号"
            v-decorator="['loginName', { rules: [{ required: true, message: '请输入登录账号' }] }]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            type="password"
            size="large"
            placeholder="请输入登录密码"
            v-decorator="['password', { rules: [{ required: true, message: '请输入登录密码' }] }]"
          />
        </a-form-item>
        <a-form-item>
          <a-button size="large" html-type="submit" block type="primary">登录</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        formLayout: 'horizontal',
        form: this.$form.createForm(this, { name: 'coordinated' })
      }
    },
    methods: {
      handleSubmit(e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (err) {
            return
          }
          this.apis
            .login(values)
            .then(response => {
              if (response.success) {
                this.$message.success('登录成功')
                localStorage.setItem('USERINFO', JSON.stringify(response.data))
                setTimeout(() => {
                  this.$router.push({ name: 'admin' })
                }, 1000)
              } else {
                this.$message.error('登录失败，' + response.message)
              }
              console.log(response)
            })
            .catch(err => {
              console.log(err)
              this.$message.error('登录失败，请稍后重试')
            })
        })
      }
    }
  }
</script>
<style scoped>
  .login {
    height: 100vh;
    background-image: url(http://203.195.138.75:82/img/login-bg.png);
  }

  .title {
    font-size: 30px;
    font-weight: bolder;
    color: white;
    padding-top: 12vh;
  }
  .login-form {
    width: 400px;
    margin: 30px auto;
  }
</style>
